import React from "react";
import * as Icon from "react-bootstrap-icons";
import { getRole } from "../../services/authenticationService";
import { poleReplacementType } from "../../types/customTypes";

type replacementHistoryArray = {
	categoryId: number;
	repairId: number;
	repairCategoryId: number;
	updatedOn: string;
	updatedBy: string;
	isResolved: boolean;
	isUpdateable: boolean;
	category: string;
	subCategory: string;
	repairDescription: string;
};

interface ReplacementHistoryProps {
	replacementHistory: replacementHistoryArray[];
	isPoleReplacement: poleReplacementType;
	onUndoReplace: () => void;
	onReplacePole: () => void;
	formatDateAndTime: (inputDateString: string) => string;
}

const ReplacementHistory: React.FC<ReplacementHistoryProps> = ({
	replacementHistory,
	isPoleReplacement,
	onUndoReplace,
	onReplacePole,
	formatDateAndTime,
}) => {
	const isViewer = getRole() === 'Viewer';
	const hasData = replacementHistory.length > 0 || isPoleReplacement.isPoleReplacement;

	if (isViewer || !hasData) return null;

	// Get unique replacement history entries
	const uniqueHistory = replacementHistory.reduce((uniqueData, data) => {
		const existingData = uniqueData.find(item => item.repairCategoryId === data.repairCategoryId);
		if (!existingData) {
			uniqueData.push(data);
		}
		return uniqueData;
	}, [] as replacementHistoryArray[]);

	return (
		<fieldset className="recommendation border rounded mt-2" id="fildset-2">
			<legend className="legend-text float-none w-auto">Replacement History</legend>
			{uniqueHistory.length > 0 && (
				uniqueHistory.map((data, index) => (
					<div className="form mx-1 mb-0" key={index}>
						<div className="form-controls mb-2" id="form-controls">
							<a
								className="float-end me-0 pointer text-reset text-end mt-1"
								data-testid="undo-pole-replacement"
								title="undo Pole Replacement"
								onClick={onUndoReplace}
							>
								<Icon.ArrowClockwise size={18} />
							</a>
							<div className="label" id="replacementHistory" data-testid="updatedOn">
								Updated On: {formatDateAndTime(data.updatedOn)}
							</div>
							<div className="label" id="replacementHistory" data-testid="updatedBy">
								Updated By: {data.updatedBy}
							</div>
						</div>
					</div>
				))
			)}
			{isPoleReplacement.isPoleReplacement && replacementHistory.length === 0 && (
				<div className="d-flex justify-content-center align-items-center">
					<button
						onClick={onReplacePole}
						className="btn btn-primary mt-2 mb-2 btn-sm"
						data-testid="replace-pole-button"
					>
						Replace Pole
					</button>
				</div>
			)}
		</fieldset>
	);
};

export default ReplacementHistory;

